import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const WS_BASE = BACKEND_URL.replace(/^https/, "wss").replace(/^http/, "ws") + "/api";

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  // Decide which token to use based on the URL path
  const url = config.url || "";
  let token = null;
  if (url.startsWith("/admin")) {
    token = localStorage.getItem("nz_admin_token");
  } else if (url.startsWith("/operator")) {
    token = localStorage.getItem("nz_operator_token");
  }
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const url = err.config?.url || "";
      if (url.startsWith("/admin")) {
        localStorage.removeItem("nz_admin_token");
        if (!window.location.pathname.startsWith("/admin/login")) {
          window.location.href = "/admin/login";
        }
      } else if (url.startsWith("/operator")) {
        localStorage.removeItem("nz_operator_token");
        if (!window.location.pathname.startsWith("/bar/login")) {
          window.location.href = "/bar/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export const formatPrice = (n) =>
  `€${Number(n || 0).toFixed(2)}`;

export const STATUS_LABEL = {
  ricevuto: "Ricevuto",
  in_preparazione: "In preparazione",
  in_arrivo: "In arrivo",
  consegnato: "Consegnato",
  rifiutato: "Rifiutato",
};

export const STATUS_FLOW = [
  "ricevuto",
  "in_preparazione",
  "in_arrivo",
  "consegnato",
];
